import React from 'react';

import logoBlue from 'assets/img/logo-blue.png';

const LoaderFull = () => {
  return (
    <div className="loader full">
      <div className="center">
        <img className="image" src={logoBlue} alt="SAAF" />
        <div className="loader" />
      </div>
    </div>
  );
};

export default LoaderFull;



// WEBPACK FOOTER //
// src/components/layout/LoaderFull.js